// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";

function reducePlayerName(pname) {
  return pname.trim().split(" ").join("").toLowerCase();
}

function calcBoardValue(units, set) {
  return Belt_Array.reduce(Belt_Array.keep(units, (function (u) {
                    if ([
                          "TFT_TrainingDummy",
                          "TFT7_TrainerDragon",
                          "TFT7_JadeStatue"
                        ].includes(u.id)) {
                      return false;
                    } else {
                      return !u.items2.includes("9OrnnTrickstersGlass");
                    }
                  })), 0, (function (acc, u) {
                var match = u.tier;
                var tmp;
                switch (match) {
                  case 2 :
                      tmp = 3;
                      break;
                  case 3 :
                      tmp = 9;
                      break;
                  case 4 :
                      tmp = 27;
                      break;
                  default:
                    tmp = 1;
                }
                return acc + Math.imul(Sd.unitCost(Data.fixId(u.id), set), tmp) | 0;
              }));
}

function getEstimatedLp(placement) {
  switch (placement) {
    case 1 :
        return 43;
    case 2 :
        return 32;
    case 3 :
        return 21;
    case 4 :
        return 10;
    case 5 :
        return -10;
    case 6 :
        return -21;
    case 7 :
        return -32;
    case 8 :
        return -43;
    default:
      return 0;
  }
}

function queueName(queueId) {
  if (queueId >= 1160) {
    if (queueId < 1181) {
      if (queueId > 1179 || queueId < 1161) {
        if (queueId >= 1180) {
          return "Soul Fighter";
        } else {
          return "Double Up";
        }
      } else if (queueId !== 1170) {
        return "Special";
      } else {
        return "Fortune's Favor";
      }
    } else if (queueId !== 6000) {
      if (queueId !== 6110) {
        return "Special";
      } else {
        return "Remix Rumble";
      }
    } else {
      return "Galaxies";
    }
  } else if (queueId >= 1101) {
    if (queueId !== 1130) {
      if (queueId !== 1150) {
        return "Special";
      } else {
        return "Double Up";
      }
    } else {
      return "Hyperroll";
    }
  } else if (queueId !== 1090) {
    if (queueId >= 1100) {
      return "Ranked";
    } else {
      return "Special";
    }
  } else {
    return "Normal";
  }
}

function getHeadlinerTraits(participant, set) {
  if (set !== 10 && set !== 100) {
    return [];
  }
  var headliners = [];
  var curr = Belt_MutableMapString.make(undefined);
  Belt_Array.forEach(Belt_Array.concatMany(Belt_Array.map(participant.units, (function (u) {
                  return Belt_Array.concat(Sd.getUnitTraits(u.id, set), Belt_Array.keepMap(u.items2, (function (i) {
                                    return Sd.emblemTrait(i, set);
                                  })));
                }))), (function (tid) {
          var c = Belt_MutableMapString.getWithDefault(curr, tid, 0);
          return Belt_MutableMapString.set(curr, tid, c + 1 | 0);
        }));
  Belt_Array.forEach(Belt_MutableMapString.toArray(curr), (function (param) {
          var tid = param[0];
          var rank = Sd.traitRank(tid, param[1], set);
          var pcRank = Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(participant.traits.find(function (t) {
                        return t.name === tid;
                      })), 0, (function (t) {
                  return t.currentTier;
                }));
          if (rank < pcRank) {
            headliners.push(tid);
            return ;
          }
          
        }));
  return headliners;
}

var dayStartOffset = 0;

export {
  reducePlayerName ,
  calcBoardValue ,
  dayStartOffset ,
  getEstimatedLp ,
  queueName ,
  getHeadlinerTraits ,
  
}
/* Sd Not a pure module */
